import {Component, Input, OnInit} from '@angular/core';
import {Structure} from "../../models/structure";
import {environment} from '../../../environments/environment';
import {MediaService} from "../../services/media/media.service";
import {DatabaseService} from "../../services/database/database.service";
import {merge} from "rxjs";
import {Media} from "../../models/media";

@Component({
  selector: 'app-structure',
  templateUrl: './structure.component.html',
  styleUrls: ['./structure.component.scss']
})

export class StructureComponent implements OnInit {
  @Input() projectId: string;
  @Input() structure: Structure;
  @Input() code: string;

  environment = environment;
  mediaLogo: Media;
  mediaImage: Media;

  constructor(
    private mediaService: MediaService,
    private databaseService: DatabaseService,
  ) {
  }

  ngOnInit() {
    merge(
      this.mediaService.getAllMyMedia(this.projectId),
      this.mediaService.onChange,
      this.databaseService.onChange
    ).subscribe(
      () => {
        this.structure = this.databaseService.database.structure;
        this.mediaLogo = this.mediaService.mediaImages.find(m => m._id == this.structure.logo);
        this.mediaImage = this.mediaService.mediaImages.find(m => m._id == this.structure.image);
      },
      e => console.log(e));
  }
}
